'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

var _styleHelpers = require('../../../styles/styleHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = (0, _extends3.default)({
  '& .notification': {
    width: '75%',
    flexDirection: 'column',
    fontFamily: 'TradeGothicLTStd-Light',
    position: 'fixed',
    bottom: '0px',
    left: '50%',
    marginLeft: '-37.5%',
    zIndex: '1000',
    overflow: 'scroll'
  },
  '& .notification .fa-close': {
    float: 'right',
    textAlign: 'right',
    cursor: 'pointer'
  }
}, (0, _styleHelpers.makeAnimation)({
  name: 'vertical-slide',
  from: { transform: 'translateY(100%)' },
  to: { transform: 'translateY(0%)' },
  on: 'transform',
  duration: '200'
}));

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref, theme) {
  var scrollClick = _ref.scrollClick;
  return (0, _extends3.default)({
    '& .notification': {
      boxShadow: theme.boxShadow,
      padding: theme.paddingBase * 50 + 'px',
      color: theme.colors.primaryInverse
    },
    '& .notification .message': {
      cursor: scrollClick ? 'pointer' : 'default',
      marginBottom: theme.marginBase * 30 + 'px'
    },
    '& .notification .title': {
      fontSize: theme.fontBase * 30 + 'px',
      letterSpacing: '1.5px',
      fontWeight: 'bold',
      textTransform: 'capitalize',
      marginBottom: theme.marginBase * 40 + 'px'
    },
    '& .notification .text': {
      fontSize: theme.fontBase * 28 + 'px'
    }
  }, (0, _objectResolvePath2.default)(theme, 'Notification.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/notifications/Notification/Notification.style.js
// module id = 495
// module chunks = 0